import React from "react";
import { toggleSidebar } from "../../utils/sidebarToggle";

function PageHeader() {
  return (
    <div className="mainHead d-flex align-items-center justify-content-between pt-3 py-3">
      <div className="headText ms-3">Inventory</div>
      <div className="headIcons d-flex me-3">
        <div className="iconMain">
          <i className="fa-solid fa-search" />
        </div>
        <a href="dashboard.html" className="iconMain ms-3 me-3">
          <i className="fa-solid fa-exclamation" style={{ color: "black" }} />
        </a>
        <div className="iconMain" id="sidebarToggle" onClick={toggleSidebar}>
          <i className="fa-solid fa-bars" />
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
